import React from 'react'
import { DialogControl } from 'spark-core-dx/components';
import { useDashboardDomainContext } from '../../DashboardDomainProvider';

const DeleteDialog = ({ isActive, closeDialog }) => {
    const {
        deleteDashboard,
    } = useDashboardDomainContext();

    return (
        <DialogControl
            className={"dashboard-dialog"}
            openDialog={isActive}
            title={"Delete Dashboard"}
            onOk={() => {
                closeDialog();
                deleteDashboard();
            }}
            onCancel={() => {
                closeDialog();
            }}
            okText={"Delete"}
        >
            <div className="dialog-text">
                Please confirm that you want to permanently delete this dashboard.
            </div>
        </DialogControl>
    )
}

export default DeleteDialog